import React from "react";
import { FullDivider } from "./SubPage";

const FAQ = [
  {
    title: "A building or photo match is wrong",
    body: "Open the building in Skyline and use Suggest an edit. Include the correct name or details so we can review the change.",
  },
  {
    title: "Report content or block a user",
    body: "Use Report on a photo or comment. To block an account, open its profile, tap the menu, and choose Block user. You can review blocked accounts under Settings → Privacy & Safety → Blocked users.",
  },
  {
    title: "Delete your account",
    body: "Open Settings and choose Delete Account. This permanently removes your Skyline account and associated photos, collections, comments, and profile data.",
  },
  {
    title: "Camera or location is unavailable",
    body: "Open the iOS Settings app, select Skyline, and allow Camera and Location While Using the App. Skyline does not use your location in the background.",
  },
];

export function SkylineSupport() {
  return (
    <div className="pt-14 bg-grey-975">
      <div className="px-5 sm:px-8 md:px-[66px] py-16 md:py-24">
        <p className="text-[11px] uppercase tracking-[0.16em] text-grey-500 mb-4">Skyline for iOS</p>
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white tracking-tight mb-6 max-w-2xl leading-none">
          Support
        </h1>
        <p className="text-[14px] text-grey-400 leading-7 max-w-2xl">
          Get help with your account, building collections, photo matching, safety, or privacy.
        </p>
      </div>
      <FullDivider />

      <div className="px-5 sm:px-8 md:px-[66px] py-10 md:py-14 grid md:grid-cols-[minmax(0,1fr)_minmax(260px,0.45fr)] gap-10 md:gap-16">
        <section>
          <h2 className="text-[15px] font-medium text-white mb-5">Common questions</h2>
          <div className="divide-y divide-white/[0.06] border-y border-white/[0.06]">
            {FAQ.map((item) => (
              <div key={item.title} className="py-6">
                <h3 className="text-[14px] font-medium text-white mb-2">{item.title}</h3>
                <p className="text-[13px] text-grey-400 leading-[1.75]">{item.body}</p>
              </div>
            ))}
          </div>
        </section>

        <aside>
          <div className="border border-white/[0.08] rounded-2xl p-6 bg-white/[0.02]">
            <h2 className="text-[15px] font-medium text-white mb-3">Contact support</h2>
            <p className="text-[13px] text-grey-400 leading-[1.75] mb-5">
              Email us with a short description, your Skyline account email, and screenshots if helpful. Do not send passwords or verification codes.
            </p>
            <a
              href="mailto:contact@cero-ai.com?subject=Skyline%20Support"
              className="inline-flex items-center justify-center rounded-full px-5 py-2.5 text-[13px] font-medium bg-white text-grey-975 hover:bg-grey-200 transition-colors"
            >
              contact@cero-ai.com
            </a>
            <p className="text-[11px] text-grey-600 mt-4">We normally respond within two business days.</p>
          </div>
          <div className="flex gap-4 mt-5 text-[12px]">
            <a className="text-grey-500 hover:text-white/70" href="/skyline/privacy">Privacy Policy</a>
            <a className="text-grey-500 hover:text-white/70" href="/skyline/terms">Terms of Service</a>
          </div>
        </aside>
      </div>
      <FullDivider />
    </div>
  );
}
